import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import figma from "../../../Assets/Images/Technology/UiUx/Figma-Image.svg";
import adobe from "../../../Assets/Images/Technology/UiUx/XD-image.svg";
import framer from "../../../Assets/Images/Technology/UiUx/Framer-image.svg";
import sketch from "../../../Assets/Images/Technology/UiUx/Sketch-image.svg";
import photoshop from "../../../Assets/Images/Technology/UiUx/Photoshop-image.svg";
import illustrator from "../../../Assets/Images/Technology/UiUx/illustrator-image.svg";
import "./UiUxMain.css";

function UiUxMain() {
  return (
    <div className="uiux-container">
      {/* Intro text (appears once) */}
      <div className="text-center uiux-intro">
        <p className="intro-text">
          Great design doesn't exist in isolation. It occurs when ideas flow
          seamlessly from rough thinking to tested interactions without getting
          lost in-between designers, developers, and stakeholders. At Quad
          Theory Ltd, our UI and UX process is influenced by tools to help us
          clearly collaborate, test early and translate intent into usable
          interfaces without friction.
        </p>
      </div>

      {/* Figma Section */}
      <div className="uiux-section">
        <div className="text-center">
          <span className="process-badge">UX & UI process</span>
          <h2 className="tool-title">
            Figma - Designing Together Without Friction
          </h2>
          <p className="tool-description">
            Figma enables our whole team to work in the same design space at the
            same time. Designers, developers, and stakeholders can monitor
            changes in real time, provide comments directly on the screen, and
            stay in sync without lengthy review cycles.
          </p>
        </div>

        <div className="image-wrapper">
          <img
            src={figma}
            alt="Figma UI Design"
            className="tool-image img-fluid"
          />
        </div>
      </div>

      {/* Adobe XD Section */}
      <div className="uiux-section">
        <div className="text-center">
          <span className="process-badge">UX & UI process</span>
          <h2 className="tool-title">
            Adobe XD - Exploring User Journeys Before They Break
          </h2>
          <p className="tool-description">
            Adobe XD helps us to get from idea to interactive prototype in a
            short time with rough wireframes. By testing flows early we can
            understand where users may hesitate or get confused long before
            development starts.
          </p>
        </div>

        <div className="image-wrapper">
          <img src={adobe} alt="Adobe XD" className="tool-image img-fluid" />
        </div>
      </div>

      {/* Framer Section */}
      <div className="uiux-section">
        <div className="text-center">
          <span className="process-badge">UX & UI process</span>
          <h2 className="tool-title">
            Framer - Prototypes that Act Like Finished Products
          </h2>
          <p className="tool-description">
            Framer allows us to create real-sounding, not simulated,
            interactions. Because they can be powered by React, developers have
            a clear understanding of the timing, behaviour, and transitions,
            which reduces the gaps between the design and implementation phases.
          </p>
        </div>

        <div className="image-wrapper">
          <img src={framer} alt="Framer" className="tool-image img-fluid" />
        </div>
      </div>

      {/* Sketch Section */}
      <div className="uiux-section">
        <div className="text-center">
          <span className="process-badge">UX & UI process</span>
          <h2 className="tool-title">
            Sketch - Rapid, Concentrated Design for Apple Platforms
          </h2>
          <p className="tool-description">
            Sketch is particularly good for designing for macOS and iOS. Its
            targeted environment supports quick iteration while staying in close
            touch with the design patterns and native interface expectations
            from Apple.
          </p>
        </div>

        <div className="image-wrapper">
          <img
            src={sketch}
            alt="Sketch UI Design"
            className="tool-image img-fluid"
          />
        </div>
      </div>

      {/* Photoshop Section */}
      <div className="uiux-section">
        <div className="text-center">
          <span className="process-badge">UX & UI process</span>
          <h2 className="tool-title">
            Photoshop - Where Visual Details Are Fine-Tuned
          </h2>
          <p className="tool-description">
            When visual accuracy is most important, Photoshop is used. From
            image editing to fine-tuning interface assets, it helps us in
            building designs that feel deliberate, polished, and consistent
            across every screen.
          </p>
        </div>

        <div className="image-wrapper">
          <img
            src={photoshop}
            alt="Photoshop"
            className="tool-image img-fluid"
          />
        </div>
      </div>

      {/* Illustrator Section */}
      <div className="uiux-section">
        <div className="text-center">
          <span className="process-badge">UX & UI process</span>
          <h2 className="tool-title">
            Illustrator - Creating Visual Systems That Scale
          </h2>
          <p className="tool-description">
            Illustrator enables us to create icons, illustrations and visuals
            which scale beautifully across devices. Its vector-based approach
            ensures clarity and consistency whether assets are in apps, web
            platforms or marketing materials.
          </p>
        </div>

        <div className="image-wrapper">
          <img
            src={illustrator}
            alt="Illustrator"
            className="tool-image img-fluid"
          />
        </div>
      </div>

      {/* Business Success Section */}
      <div className="uiux-section">
        <div className="text-center">
          <h2 className="tool-title">
            Designing For How People Actually Use Products
          </h2>
          <p className="tool-description">
            Most users don't read instructions or explore all the features. They
            click, hesitate, make mistakes, and move on quickly. At Quad Theory
            Ltd, we believe our UI and UX efforts begin with that reality. We
            are attentive to where people slow down, get confused, and give up
            on tasks. Design decisions are made to eliminate friction, rather
            than impress. When things work well, users don't notice the design
            at all, they just get what they came for and move on.
          </p>
        </div>
      </div>
    </div>
  );
}

export default UiUxMain;
